// extracted by mini-css-extract-plugin
export default {"privacyContainer":"Privacy_privacyContainer__o2mzc"};